module.exports = __webpack_public_path__ + "7891-logo-bovine-verse.png";